export const DOBAVLJAC_V1ResourcesDE: DOBAVLJAC_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
  input: {
    street: {
      label: "Straße und Nummer",
      name: "street",
      error: "Sie haben keine Straße eingegeben",
    },
    city: {
      label: "Stadt",
      name: "city",
      error: "Sie haben keine Stadt eingegeben",
    },
    zipCode: {
      label: "Postleitzahl",
      name: "zipCode",
      error: "Sie haben keine Postleitzahl eingegeben",
      validation: "Ungültige Nummer",
    },
    country: {
      label: "Land",
      name: "country",
      error: "Sie haben kein Land eingegeben",
    },
    phone: {
      label: "Telefon",
      name: "phoneNumber",
      error: "Sie haben kein Telefon eingegeben",
      validation: "Ungültige Nummer",
    },
    idCompanyNumber: {
      label: "ID-Nummer",
      name: "idTax",
      error: "Sie haben keine ID-Nummer eingegeben",
      validation: "Ungültige Nummer",
    },
    vatCompanyNumber: {
      label: "USt-Nummer",
      name: "vatCompanyNumber",
      error: "Sie haben keine USt-Nummer eingegeben",
      validation: "Ungültige Nummer",
    },
    name: {
      label: "Lieferantenname",
      name: "name",
      placeholder: "Bitte geben Sie den Lieferantennamen ein",
      error: "",
    },
    productType: {
      label: "Produkttyp",
      name: "productType",
      placeholder: "Bitte geben Sie den Produkttyp ein",
      error: "",
    },
    dialogSuccess: {
      title: "Erfolgreich!",
      body: "Sie haben das Unternehmen zur Datenbank hinzugefügt!",
      buttonOk: "OK",
    },
  },
};

interface InputField {
  label: string;
  name: string;
  error: string;
  validation?: string;
  placeholder?: string;
}

interface DialogSuccess {
  title: string;
  body: string;
  buttonOk: string;
}

interface Input {
  street: InputField;
  city: InputField;
  zipCode: InputField;
  country: InputField;
  phone: InputField;
  idCompanyNumber: InputField;
  vatCompanyNumber: InputField;
  name: InputField;
  productType: InputField;
  dialogSuccess: DialogSuccess;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DOBAVLJAC_V1ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  input: Input;
  errors: IErrors;
}
